import React from "react";
import { useSelector } from "react-redux";
import useMarketplacesFilter from "../../../../components/FilterMarketplacesProvider/useFilterMarketplaces";
import CTable from "../../../../components/Table";
import { useStatusGroup } from "../../StatusGroupProvider";
import Footer from "./Footer";
import defaultColumns from "./columns";
import itemsToRows from "./itemsToRows";
import { TableFC } from "./types";
const Table: TableFC = () => {
  const { active: filteringMarketplaces } = useMarketplacesFilter();
  const { statusGroup } = useStatusGroup();
  const { isLoading, items } = useSelector(
    ({ statisticSourceOrders: { [statusGroup]: statisticSourceOrders } }) => ({
      items: statisticSourceOrders.data,
      isLoading: statisticSourceOrders.sending,
    })
  );
  let columns = [...defaultColumns];
  if (filteringMarketplaces.length <= 1) {
    let marketplaceColumn;
    [marketplaceColumn, ...columns] = defaultColumns;
  }

  return (
    <CTable
      columns={columns}
      rows={items ? items.reduce(itemsToRows, []) : []}
      loading={isLoading}
      disablePagination
      Footer={<Footer order={items} loading={isLoading} />}
    />
  );
};

export default Table;
